<template>
  <div v-if="category" class="ticket-wrap">

    <h3 class="component-title">{{ category.passgroup_name }}</h3>

    <movie-product-groups v-for="(data, index) in this.category.productgroups" :key="index"
                          :productGroups="data"
                          :categoryNum="categoryNum"
                          :productGroupNum="index"
                          :voucher-type="category.passgroup_type"
                          :content-id="contentId"/>
  </div>
</template>

<script>
import MovieProductGroups from '@/components/play/bottom-tab/MovieProductGroups'

export default {
  components: {
    MovieProductGroups
  },
  props: {
    category: {
      type: Object,
      required: true
    },
    categoryNum: {
      type: Number,
      required: true
    },
    contentId: {
      type: String
    }
  },
  methods: {
    // 이용가능 기기 · 화질안내
    goGuide () {
      // this.$events.$emit('goGuide');
    }
  },
  mounted () {
    // let scroll = this.$utils.queryString.getQueryParamValue('scroll')
    // let scrollElement = document.getElementById(scroll)
    // if (scrollElement) {
    //   window.onload = function () {
    //     window.scroll(0, scrollElement.offsetTop)
    //   }
    // }
  }
}
</script>
<style scoped>
  .ticket-wrap {
    margin-bottom: 25px;
  }
  .component-title {
    padding: 5px 10px 10px;
    font-weight: 700;
    font-size: 15px;
    color: #23212a;
    position: relative;
  }
</style>
